import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-accordian',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './accordian.component.html',
    styleUrls: ['./accordian.component.scss'],
    host : {
        '[class.open]' : 'isOpen',
        '[class.closed]' : '!isOpen',
    }
})
export class AccordianComponent {
    @Input() title: string = '';
    isOpen: boolean = true;

    get SafeText(): string {
        return this.title
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
    }

    get headerIds(): string {
        return `accordian_header_${this.SafeText}`;
    }


    get panelIds(): string {
        return `accordian_panel_${this.SafeText}`;
    }

    toggle() {
        this.isOpen = !this.isOpen
    }

    onKeyPress(event: KeyboardEvent) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            this.toggle();
        }
    }


}
